<form autocomplete="off" [formGroup]="innerForm">
    <div class="float-left smart-tag-form-container container" *ngIf="smartTagModel !== null">
        <div class="row">
            <div class="col-md-6">
                <cv-dropdown
                        [placeholder]="'Estimate update timeframe?'"
                        [optionText]="'label'"
                        [selectedValue]="dropdownInitialValues['timeframe']"
                        [options]="smartTagTimeframeOptions"
                        (valuesChange)="onDropdownValueChange('timeframe', $event)">
                </cv-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="col-md-10">
                <label>Description:</label>
                <textarea name="description"
                          formControlName="description"
                          (keyup)="smartTagModel.description = $event.currentTarget['value'];"
                          id="report-image-description" name="report-image-description" rows="3"
                          cols="50" [maxLength]="150"></textarea>
            </div>
        </div>
    </div>
</form>
